import React, { useState, useEffect } from "react";
import "../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { ToastContainer, toast } from "react-toastify";
import ReLoginModal from "./ReLoginModal";
import api from "../util/axios";

type Requisition = {
  customer: any;
  approvalNumber: string;
};

const SingleSlipModal = ({ handleSingle, setGetApprovalDetails }: any) => {
  const token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const [reLogin, setReLogin] = useState(false);

  const [getRequisition, setGetRequisition] = useState<Requisition[]>([]);

  function queryRequisition() {
    return api
      .get("/requisition", {
        headers: headers,
      })
      .then((res) => {
        const approvedRequisitions = res.data.data.filter(
          (requisition: any) => requisition.status === "APPROVED"
        );
        setGetRequisition(approvedRequisitions);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        if (error.response.data.message === "jwt expired" || error.response.data.message === "jwt malformed") {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
      });
  }

  useEffect(() => {
    queryRequisition();
  }, []);

  const [selectedRequi, setSelectedRequi] = useState("");
  const handleRequiClick = (type: any) => {
    setSelectedRequi(type?.customer?.businessName);
    setGetApprovalDetails(type);
    // console.log(type);
  };

  return (
    <div className="modal">
      <div className="catModal adCus">
        <ToastContainer />
        <div className="catModalTop">
          <h4>Approve</h4>
          <ImCancelCircle className="catCancel" onClick={handleSingle} />
        </div>
        <div className="line"></div>
        {reLogin ? <ReLoginModal /> : null}
        <div className="cusmm">
          {getRequisition.map((user, inx) => {
            return (
              <p
                className={`${selectedRequi === user?.customer?.businessName
                  ? "payT payDark"
                  : "payT"
                  }`}
                key={inx}
                onClick={() => handleRequiClick(user)}
              >
                {user?.customer?.businessName}
              </p>
            );
          })}
        </div>

        <div className="catModalBtn">
          <button className="catBtn1" onClick={handleSingle}>
            Accept
          </button>
          <button className="catBtn2" onClick={handleSingle}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleSlipModal;
